export const PODCAST_GENRE = Object.freeze({
  ARTS: 'Arts',
  ARTS_BOOKS: 'Books',
  ARTS_DESIGN: 'Design',
  ARTS_FASHION_AND_BEAUTY: 'Fashion & Beauty',
  ARTS_FOOD: 'Food',
  ARTS_PERFORMING_ARTS: 'Performing Arts',
  ARTS_VISUAL_ARTS: 'Visual Arts',

  BUSINESS: 'Business',
  BUSINESS_CAREERS: 'Careers',
  BUSINESS_ENTREPRENEURSHIP: 'Entrepreneurship',
  BUSINESS_INVESTING: 'Investing',
  BUSINESS_MANAGEMENT: 'Management',
  BUSINESS_MARKETING: 'Marketing',
  BUSINESS_NON_PROFIT: 'Non-Profit',

  COMEDY: 'Comedy',
  COMEDY_INTERVIEWS: 'Comedy Interviews',
  COMEDY_IMPROV: 'Improv',
  COMEDY_STANDUP: 'Stand-Up',

  EDUCATION: 'Education',
  EDUCATION_COURSES: 'Courses',
  EDUCATION_HOW_TO: 'How to',
  EDUCATION_LANGUAGE_LEARNING: 'Language Learning',
  EDUCATION_SELF_IMPROVEMENT: 'Self-Improvement',

  FICTION: 'Fiction',
  FICTION_COMEDY_FICTION: 'Comedy Fiction',
  FICTION_DRAMA: 'Drama',
  FICTION_SCIENCE_FICTION: 'Science Fiction',

  GOVERNMENT: 'Government',
  HISTORY: 'History',

  HEALTH_AND_FITNESS: 'Health & Fitness',
  HEALTH_AND_FITNESS_ALTERNATIVE_HEALTH: 'Alternative Health',
  HEALTH_AND_FITNESS_FITNESS: 'Fitness',
  HEALTH_AND_FITNESS_MEDICINE: 'Medicine',
  HEALTH_AND_FITNESS_MENTAL_HEALTH: 'Mental Health',
  HEALTH_AND_FITNESS_NUTRITION: 'Nutrition',
  HEALTH_AND_FITNESS_SEXUALITY: 'Sexuality',

  KIDS_AND_FAMILY: 'Kids & Family',
  KIDS_AND_FAMILY_EDUCATION_FOR_KIDS: 'Education for Kids',
  KIDS_AND_FAMILY_PARENTING: 'Parenting',
  KIDS_AND_FAMILY_PETS_AND_ANIMALS: 'Pets & Animals',
  KIDS_AND_FAMILY_STORIES_FOR_KIDS: 'Stories for Kids',

  LEISURE: 'Leisure',
  LEISURE_ANIMATION_AND_MANGA: 'Animation & Manga',
  LEISURE_AUTOMOTIVE: 'Automotive',
  LEISURE_AVIATION: 'Aviation',
  LEISURE_CRAFTS: 'Crafts',
  LEISURE_GAMES: 'Games',
  LEISURE_HOBBIES: 'Hobbies',
  LEISURE_HOME_AND_GARDEN: 'Home & Garden',
  LEISURE_VIDEO_GAMES: 'Video Games',

  MUSIC: 'Music',
  MUSIC_COMMENTARY: 'Music Commentary',
  MUSIC_HISTORY: 'Music History',
  MUSIC_INTERVIEWS: 'Music Interviews',

  NEWS: 'News',
  NEWS_BUSINESS: 'Business News',
  NEWS_DAILY_NEWS: 'Daily News',
  NEWS_ENTERTAINMENT: 'Entertainment News',
  NEWS_COMMENTARY: 'News Commentary',
  NEWS_POLITICS: 'Politics',
  NEWS_SPORTS: 'Sports News',
  NEWS_TECH: 'Tech News',

  RELIGION_AND_SPIRITUALITY: 'Religion & Spirituality',
  RELIGION_AND_SPIRITUALITY_BUDDHISM: 'Buddhism',
  RELIGION_AND_SPIRITUALITY_CHRISTIANITY: 'Christianity',
  RELIGION_AND_SPIRITUALITY_HINDUISM: 'Hinduism',
  RELIGION_AND_SPIRITUALITY_ISLAM: 'Islam',
  RELIGION_AND_SPIRITUALITY_JUDAISM: 'Judaism',
  RELIGION_AND_SPIRITUALITY_RELIGION: 'Religion',
  RELIGION_AND_SPIRITUALITY_SPIRITUALITY: 'Spirituality',

  SCIENCE: 'Science',
  SCIENCE_ASTRONOMY: 'Astronomy',
  SCIENCE_CHEMISTRY: 'Chemistry',
  SCIENCE_EARTH_SCIENCES: 'Earth Sciences',
  SCIENCE_LIFE_SCIENCES: 'Life Sciences',
  SCIENCE_MATHEMATICS: 'Mathematics',
  SCIENCE_NATURAL_SCIENCES: 'Natural Sciences',
  SCIENCE_NATURE: 'Nature',
  SCIENCE_PHYSICS: 'Physics',
  SCIENCE_SOCIAL_SCIENCES: 'Social Sciences',

  SOCIETY_AND_CULTURE: 'Society & Culture',
  SOCIETY_AND_CULTURE_DOCUMENTARY: 'Documentary',
  SOCIETY_AND_CULTURE_PERSONAL_JOURNALS: 'Personal Journals',
  SOCIETY_AND_CULTURE_PHILOSOPHY: 'Philosophy',
  SOCIETY_AND_CULTURE_PLACES_AND_TRAVEL: 'Places & Travel',
  SOCIETY_AND_CULTURE_RELATIONSHIPS: 'Relationships',

  SPORTS: 'Sports',
  SPORTS_BASEBALL: 'Baseball',
  SPORTS_BASKETBALL: 'Basketball',
  SPORTS_CRICKET: 'Cricket',
  SPORTS_FANTASY_SPORTS: 'Fantasy Sports',
  SPORTS_FOOTBALL: 'Football',
  SPORTS_GOLF: 'Golf',
  SPORTS_HOCKEY: 'Hockey',
  SPORTS_RUGBY: 'Rugby',
  SPORTS_RUNNING: 'Running',
  SPORTS_SOCCER: 'Soccer',
  SPORTS_SWIMMING: 'Swimming',
  SPORTS_TENNIS: 'Tennis',
  SPORTS_VOLLEYBALL: 'Volleyball',
  SPORTS_WILDERNESS: 'Wilderness',
  SPORTS_WRESTLING: 'Wrestling',

  TECHNOLOGY: 'Technology',
  TRUE_CRIME: 'True Crime',

  TV_AND_FILM: 'TV & Film',
  TV_AND_FILM_AFTER_SHOWS: 'After Shows',
  TV_AND_FILM_HISTORY: 'Film History',
  TV_AND_FILM_INTERVIEWS: 'Film Interviews',
  TV_AND_FILM_FILM_REVIEWS: 'Film Reviews',
  TV_AND_FILM_TV_REVIEWS: 'TV Reviews',
});
export type PodcastGenre = (typeof PODCAST_GENRE)[keyof typeof PODCAST_GENRE];

export const PODCAST_GENRE_GROUPED = [
  {
    title: PODCAST_GENRE.ARTS,
    data: [
      PODCAST_GENRE.ARTS_BOOKS,
      PODCAST_GENRE.ARTS_DESIGN,
      PODCAST_GENRE.ARTS_FASHION_AND_BEAUTY,
      PODCAST_GENRE.ARTS_FOOD,
      PODCAST_GENRE.ARTS_PERFORMING_ARTS,
      PODCAST_GENRE.ARTS_VISUAL_ARTS,
    ],
  },
  {
    title: PODCAST_GENRE.BUSINESS,
    data: [
      PODCAST_GENRE.BUSINESS_CAREERS,
      PODCAST_GENRE.BUSINESS_ENTREPRENEURSHIP,
      PODCAST_GENRE.BUSINESS_INVESTING,
      PODCAST_GENRE.BUSINESS_MANAGEMENT,
      PODCAST_GENRE.BUSINESS_MARKETING,
      PODCAST_GENRE.BUSINESS_NON_PROFIT,
    ],
  },
  {
    title: PODCAST_GENRE.COMEDY,
    data: [PODCAST_GENRE.COMEDY_INTERVIEWS, PODCAST_GENRE.COMEDY_IMPROV, PODCAST_GENRE.COMEDY_STANDUP],
  },
  {
    title: PODCAST_GENRE.EDUCATION,
    data: [
      PODCAST_GENRE.EDUCATION_COURSES,
      PODCAST_GENRE.EDUCATION_HOW_TO,
      PODCAST_GENRE.EDUCATION_LANGUAGE_LEARNING,
      PODCAST_GENRE.EDUCATION_SELF_IMPROVEMENT,
    ],
  },
  {
    title: PODCAST_GENRE.FICTION,
    data: [PODCAST_GENRE.FICTION_COMEDY_FICTION, PODCAST_GENRE.FICTION_DRAMA, PODCAST_GENRE.FICTION_SCIENCE_FICTION],
  },
  {
    title: PODCAST_GENRE.GOVERNMENT,
    data: [],
  },
  {
    title: PODCAST_GENRE.HISTORY,
    data: [],
  },
  {
    title: PODCAST_GENRE.HEALTH_AND_FITNESS,
    data: [
      PODCAST_GENRE.HEALTH_AND_FITNESS_ALTERNATIVE_HEALTH,
      PODCAST_GENRE.HEALTH_AND_FITNESS_FITNESS,
      PODCAST_GENRE.HEALTH_AND_FITNESS_MEDICINE,
      PODCAST_GENRE.HEALTH_AND_FITNESS_MENTAL_HEALTH,
      PODCAST_GENRE.HEALTH_AND_FITNESS_NUTRITION,
      PODCAST_GENRE.HEALTH_AND_FITNESS_SEXUALITY,
    ],
  },
  {
    title: PODCAST_GENRE.KIDS_AND_FAMILY,
    data: [
      PODCAST_GENRE.KIDS_AND_FAMILY_EDUCATION_FOR_KIDS,
      PODCAST_GENRE.KIDS_AND_FAMILY_PARENTING,
      PODCAST_GENRE.KIDS_AND_FAMILY_PETS_AND_ANIMALS,
      PODCAST_GENRE.KIDS_AND_FAMILY_STORIES_FOR_KIDS,
    ],
  },
  {
    title: PODCAST_GENRE.LEISURE,
    data: [
      PODCAST_GENRE.LEISURE_ANIMATION_AND_MANGA,
      PODCAST_GENRE.LEISURE_AUTOMOTIVE,
      PODCAST_GENRE.LEISURE_AVIATION,
      PODCAST_GENRE.LEISURE_CRAFTS,
      PODCAST_GENRE.LEISURE_GAMES,
      PODCAST_GENRE.LEISURE_HOBBIES,
      PODCAST_GENRE.LEISURE_HOME_AND_GARDEN,
      PODCAST_GENRE.LEISURE_VIDEO_GAMES,
    ],
  },
  {
    title: PODCAST_GENRE.MUSIC,
    data: [PODCAST_GENRE.MUSIC_COMMENTARY, PODCAST_GENRE.MUSIC_HISTORY, PODCAST_GENRE.MUSIC_INTERVIEWS],
  },
  {
    title: PODCAST_GENRE.NEWS,
    data: [
      PODCAST_GENRE.NEWS_BUSINESS,
      PODCAST_GENRE.NEWS_DAILY_NEWS,
      PODCAST_GENRE.NEWS_ENTERTAINMENT,
      PODCAST_GENRE.NEWS_COMMENTARY,
      PODCAST_GENRE.NEWS_POLITICS,
      PODCAST_GENRE.NEWS_SPORTS,
      PODCAST_GENRE.NEWS_TECH,
    ],
  },
  {
    title: PODCAST_GENRE.RELIGION_AND_SPIRITUALITY,
    data: [
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_BUDDHISM,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_CHRISTIANITY,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_HINDUISM,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_ISLAM,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_JUDAISM,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_RELIGION,
      PODCAST_GENRE.RELIGION_AND_SPIRITUALITY_SPIRITUALITY,
    ],
  },
  {
    title: PODCAST_GENRE.SCIENCE,
    data: [
      PODCAST_GENRE.SCIENCE_ASTRONOMY,
      PODCAST_GENRE.SCIENCE_CHEMISTRY,
      PODCAST_GENRE.SCIENCE_EARTH_SCIENCES,
      PODCAST_GENRE.SCIENCE_LIFE_SCIENCES,
      PODCAST_GENRE.SCIENCE_MATHEMATICS,
      PODCAST_GENRE.SCIENCE_NATURAL_SCIENCES,
      PODCAST_GENRE.SCIENCE_NATURE,
      PODCAST_GENRE.SCIENCE_PHYSICS,
      PODCAST_GENRE.SCIENCE_SOCIAL_SCIENCES,
    ],
  },
  {
    title: PODCAST_GENRE.SOCIETY_AND_CULTURE,
    data: [
      PODCAST_GENRE.SOCIETY_AND_CULTURE_DOCUMENTARY,
      PODCAST_GENRE.SOCIETY_AND_CULTURE_PERSONAL_JOURNALS,
      PODCAST_GENRE.SOCIETY_AND_CULTURE_PHILOSOPHY,
      PODCAST_GENRE.SOCIETY_AND_CULTURE_PLACES_AND_TRAVEL,
      PODCAST_GENRE.SOCIETY_AND_CULTURE_RELATIONSHIPS,
    ],
  },
  {
    title: PODCAST_GENRE.SPORTS,
    data: [
      PODCAST_GENRE.SPORTS_BASEBALL,
      PODCAST_GENRE.SPORTS_BASKETBALL,
      PODCAST_GENRE.SPORTS_CRICKET,
      PODCAST_GENRE.SPORTS_FANTASY_SPORTS,
      PODCAST_GENRE.SPORTS_FOOTBALL,
      PODCAST_GENRE.SPORTS_GOLF,
      PODCAST_GENRE.SPORTS_HOCKEY,
      PODCAST_GENRE.SPORTS_RUGBY,
      PODCAST_GENRE.SPORTS_RUNNING,
      PODCAST_GENRE.SPORTS_SOCCER,
      PODCAST_GENRE.SPORTS_SWIMMING,
      PODCAST_GENRE.SPORTS_TENNIS,
      PODCAST_GENRE.SPORTS_VOLLEYBALL,
      PODCAST_GENRE.SPORTS_WILDERNESS,
      PODCAST_GENRE.SPORTS_WRESTLING,
    ],
  },
  {
    title: PODCAST_GENRE.TECHNOLOGY,
    data: [],
  },
  {
    title: PODCAST_GENRE.TRUE_CRIME,
    data: [],
  },
  {
    title: PODCAST_GENRE.TV_AND_FILM,
    data: [
      PODCAST_GENRE.TV_AND_FILM_AFTER_SHOWS,
      PODCAST_GENRE.TV_AND_FILM_HISTORY,
      PODCAST_GENRE.TV_AND_FILM_INTERVIEWS,
      PODCAST_GENRE.TV_AND_FILM_FILM_REVIEWS,
      PODCAST_GENRE.TV_AND_FILM_TV_REVIEWS,
    ],
  },
];
